<template>
  <div>
    <!-- modal -->
    <b-modal
      v-model="dialog"
      size="lg"
      title="Edit data"
      ok-only
      ok-title="Exit"
    >
      <b-card-text>
        <b-row class="invoice-add">
          <b-col cols="12" xl="12" md="12">
            <b-form enctype="multipart/form-data" @submit.prevent>
              <b-card no-body class="invoice-preview-card">
                <b-card-body class="invoice-padding form-item-section">
                  <div ref="form" class="repeater-form">
                    <b-row ref="row" class="pb-2">
                      <b-form @submit.prevent>
                        <b-row>
                          <b-col cols="12">
                            <b-form-group label="Category">
                              <v-select
                                v-model="category"
                                :dir="
                                  $store.state.appConfig.isRTL ? 'rtl' : 'ltr'
                                "
                                label="title"
                                :options="option"
                              />
                            </b-form-group>
                          </b-col>
                          <b-col cols="12">
                            <b-form-group label="Campaign Name">
                              <b-input-group class="input-group-merge">
                                <b-form-input
                                  id="content_title"
                                  v-model="content_title"
                                  type="text"
                                  placeholder="name"
                                />
                              </b-input-group>
                              <b-alert
                                v-if="check.content_title == true"
                                variant="danger"
                                show
                              >
                                <span>Please Enter</span>
                              </b-alert>
                            </b-form-group>
                          </b-col>

                          <b-col cols="12">
                            <!-- image -->
                            <div v-if="content_Image == null">
                              <b-row class="match-height">
                                <b-col>
                                  <b-container fluid class="p-1 bg-dark">
                                    <b-row>
                                      <b-col>
                                        <b-img
                                          thumbnail
                                          fluid
                                          :src="
                                            require('@/assets/images/img/cloud-computing.png')
                                          "
                                        />
                                      </b-col>
                                    </b-row>
                                  </b-container>
                                  <b-form-file
                                    placeholder="อัพโหลดรูป"
                                    ref="refInputEl"
                                    type="file"
                                    accept=".jpeg,.png,.jpg,GIF"
                                    :hidden="true"
                                    @change="onFileChange"
                                  />
                                </b-col>
                              </b-row>
                            </div>
                            <div class="pa-5" id="Box" v-else>
                              <b-row class="match-height">
                                <b-col>
                                  <b-container fluid class="p-1 bg-dark">
                                    <b-row>
                                      <b-col>
                                        <b-button
                                          v-if="content_Image"
                                          v-ripple.400="
                                            'rgba(255, 255, 255, 0.15)'
                                          "
                                          size="sm"
                                          variant="relief-danger"
                                          @click="delete_img"
                                        >
                                          delete
                                        </b-button>
                                        <b-img
                                          thumbnail
                                          fluid
                                          :src="content_Image"
                                        />
                                      </b-col>
                                    </b-row>
                                  </b-container>
                                  <b-form-file
                                    placeholder="เปลี่ยนรูปภาพ"
                                    ref="refInputEl"
                                    type="file"
                                    accept=".jpeg,.png,.jpg,GIF"
                                    :hidden="true"
                                    @change="onFileChange"
                                  />
                                </b-col>
                              </b-row>
                            </div>
                            <!-- image -->
                          </b-col>

                          <b-col cols="12">
                            <b-form-group label="Content Detail">
                              <quill-editor
                                v-model="content_detail"
                                :options="snowOption"
                              />
                            </b-form-group>
                          </b-col>
                          <!-- submit and reset -->
                          <b-col>
                            <br /><br />
                            <b-button
                              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                              type="submit"
                              variant="primary"
                              class="mr-1"
                              @click="update()"
                            >
                              Update
                            </b-button>
                          </b-col>
                        </b-row>
                      </b-form>
                    </b-row>
                  </div>
                </b-card-body>
              </b-card>
            </b-form>
          </b-col>
        </b-row>
      </b-card-text>
    </b-modal>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardBody,
  BButton,
  BCardText,
  BListGroupItem,
  BCardTitle,
  BForm,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupPrepend,
  BFormTextarea,
  BCardCode,
  BFormFile,
  BImg,
  BMedia,
  VBModal,
  BFormDatepicker,
  BCarousel,
  BCarouselSlide,
  BContainer,
  BFormText,
  BAlert,
} from "bootstrap-vue";
import Swal from "sweetalert2";
import Ripple from "vue-ripple-directive";
import "animate.css";
import api from "@/api";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import vSelect from "vue-select";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BButton,
    BCardText,
    BForm,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BFormTextarea,
    BCardCode,
    BFormFile,
    BListGroupItem,
    BCardTitle,
    BImg,
    BMedia,
    VBModal,
    BFormDatepicker,
    BCarousel,
    BCarouselSlide,
    BContainer,
    BFormText,
    BAlert,
    quillEditor,
    vSelect,
  },
  directives: {
    "b-modal": VBModal,
    Ripple,
  },
  data() {
    return {
            snowOption: {
        theme: 'snow',
      },
      id: null,
      dialog: null,
      content_Image: null,
      content_title: null,
      content_detail: null,
      check: {
        content_Image: false,
        content_title: false,
        content_detail: false,
      },
      category: "ทั่วไป",
      option: [],
    };
  },
  methods: {
    update() {
      if (this.content_title) {
        Swal.fire({
          title: "ยืนยันการบันทึกข้อมูล",
          text: "",
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "ยืนยัน",
          cancelButtonText: "ยกเลิก",
          showLoaderOnConfirm: true,
          preConfirm: () => {},
        }).then((result) => {
          if (result.isConfirmed) {
            let formData = new FormData();
            if (this.category.title) {
              var category_data = this.category.title;
            } else {
              var category_data = this.category;
            }
            formData.append("file", this.fileImage);
            formData.append("id", this.id);
            formData.append("content_title", this.content_title);
            formData.append("content_detail", this.content_detail);
            formData.append("category", category_data);
            formData.append("content_Image", this.content_Image);
            console.log(this.fileImage);
            console.log(this.content_title);
            console.log(this.content_detail);
            console.log(this.category.title);
            console.log(this.content_Image);
            api.post("/contentupdate", formData).then((response) => {
              console.log("response", response);
              if (response) {
                Swal.fire({
                  icon: "success",
                  title: "success",
                  showConfirmButton: false,
                  timer: 1500,
                });
                this.dialog = false;
                this.refresh();
                  window.location.reload();
              }
            });
          }
        });
      } else {
        if (!this.content_title) {
          this.check.content_title = true;
          console.log("content_title null");
        }
        this.$swal({
          title: "Please complete the information.",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          showClass: {
            popup: "animate__animated animate__bounceIn",
          },
          buttonsStyling: false,
        });
      }
    },
    delete_img() {
      this.content_Image = "";
      this.fileImage = "";
      console.log("set content_Image = null", this.content_Image);
    },

    async showModaledit(id) {
      this.check.content_Image = false;
      this.check.content_title = false;
      this.check.content_detail = false;
      console.log("id", id);
      this.id = id;
      const params = {
        id: id,
      };
      // get date axios
      api.post("/contentget", params).then((response) => {
        console.log(response.data);
        console.log((this.items = response.data.codes));
        console.log((this.totalRows = response.data.total));
        this.amount = "จำนวนโค้ดทั้งหมด " + this.totalRows + " โค้ด";
        for (let item of response.data.data) {
          (this.content_Image = item.content_Image),
            (this.content_title = item.content_title),
            (this.content_detail = item.content_detail)(
              (this.category = item.category)
            );
        }
      });

      api
        .post("/contentgettype", params)
        .then((response) => {
          this.option = response.data.data;
        })
        
        .catch((error) => {});
      this.dialog = true;
    },

    onFileChange(e) {
      this.fileImage = e.target.files[0];
      console.log("file", this.fileImage);
      const image = e.target.files[0];
      this.content_Image = URL.createObjectURL(image); ///show
    },
    refresh() {
      this.$emit("loaddata", "loaddata");
    },
  },
};
</script>